import {
  ServicesPageBody,
} from 'pages/servicesPage/ui/style.ts';
import React, {useContext} from 'react';
import {ConfigContext} from '../../../app/App.tsx';
import {getServicesNav, NonClickableHudNavItem} from 'widgets/hud/model/routes.ts';
import {HudButton} from "widgets/hud/ui/HudButton";
import {OurServicesBody} from "widgets/ourServicesModal/ui/styles.ts";

export const ServicesPage = () => {
  const appConfig = useContext(ConfigContext);
  const servicesList = getServicesNav(appConfig) as NonClickableHudNavItem[];

  return (
    <ServicesPageBody>
      {servicesList.map((item) => {
        if (item.id !== 'yourhive') {
          return <HudButton key={item.id} item={item} aria-label={item.label} />;
        }
        const Icon = item.icon;
        
        return (
          <a href={item.to} title={item.label} target="_blank">
            <Icon />
            <span>{item.label}</span>
          </a>
        );
      })}
    </ServicesPageBody>
  );
};
